"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkSasToken = checkSasToken;
exports.getSystem = getSystem;
exports.getToken = getToken;
exports.removeSystem = removeSystem;
exports.removeToken = removeToken;
exports.setSystem = setSystem;
exports.setToken = setToken;
var _regenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _store = _interopRequireDefault(require("@/store"));
var _storage = require("@/utils/storage");
var _login = _interopRequireDefault(require("@/http/interface/base/login"));
// import Cookies from 'js-cookie'

var TokenKey = 'Boat-Admin-Vue-Token';
var SystemId = 'System-Id';
function getToken() {
  return _storage.SessionStorage.getItem(TokenKey);
}
function setToken(token) {
  return _storage.SessionStorage.setItem(TokenKey, token);
}
function removeToken() {
  return _storage.SessionStorage.removeItem(TokenKey);
}
function getSystem() {
  return _storage.SessionStorage.getItem(SystemId);
}
function setSystem(id) {
  return _storage.SessionStorage.setItem(SystemId, id);
}
function removeSystem() {
  return _storage.SessionStorage.removeItem(SystemId);
}
function checkSasToken(_x) {
  return _checkSasToken.apply(this, arguments);
}
function _checkSasToken() {
  _checkSasToken = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(config) {
    var res, expiredTime, _t;
    return (0, _regenerator2.default)().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!config.url.includes('/protected/app/check_token')) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          if (!(_store.default.getters.sasTokenExpiredTime < new Date().getTime().toString())) {
            _context.n = 5;
            break;
          }
          _context.p = 2;
          _context.n = 3;
          return _login.default.checkSasToken();
        case 3:
          res = _context.v;
          if (res.success) {
            _store.default.dispatch('user/setSasToken', res.data.sasToken);
            expiredTime = (new Date().getTime() + 15 * 60 * 1000).toString();
            _store.default.dispatch('user/setSasTokenExpiredTime', expiredTime);
          }
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          console.log(_t);
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[2, 4]]);
  }));
  return _checkSasToken.apply(this, arguments);
}